import React from 'react'

const noop = () => {}

export const MapFocusContext = React.createContext({ focusId: null, setFocus: noop })

export const withFocus = Component => props => (
  <MapFocusContext.Consumer>
    {({ focusId, setFocus }) => <Component mapFocusId={focusId} setFocus={setFocus} {...props} />}
  </MapFocusContext.Consumer>
)
